// AUTO-GENERATED by scripts/extract-tokens.ts — do not edit by hand.

/** 정본(nol-design-tokens)의 breakpoint. **이름은 정본을 따른다.**
 *
 * core-ui 의 데스크탑 레이아웃 전환점은 `BREAKPOINT_LAPTOP`(1024) 이다 — `useIsDesktop()` ·
 * `desktopBreakpoint` prop · `data-core-ui-breakpoint='desktop'` 이 가리키는 그 임계값이다.
 * `desktop`(1320)은 컨테이너 바깥 폭 맥락의 값이고 전환점이 아니다.
 */
export const BREAKPOINT_TABLET = 600;
export const BREAKPOINT_TABLET_LG = 768;
export const BREAKPOINT_LAPTOP = 1024;
export const BREAKPOINT_DESKTOP = 1320;
/** 콘텐츠 최대 폭. padding 을 **뺀** 안쪽이다 (정본 container-max). */
export const CONTAINER_MAX = 1240;
